<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.dashboard") }}  
  template(v-if="isOperator")
    dashboardop
  template(v-else)    
    dashboardad
</template>

<script>
import dashboardop from "@/views/system/_dashboardop.vue";
import dashboardad from "@/views/system/_dashboardad.vue";

export default {
  components: { 
    dashboardop,
    dashboardad
  },
  data: () => ({
  }),
  computed: {
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
  },
  mounted: function() {
  },
  methods: {  }
};
</script>